export const PLUGGY_PRODUCT_LABELS: Record<string, string> = {
  ACCOUNTS: 'Contas',
  TRANSACTIONS: 'Transações',
  CREDIT_CARDS: 'Cartões',
  IDENTITY: 'Identidade',
  INVESTMENTS: 'Investimentos',
  INVESTMENTS_TRANSACTIONS: 'Movimentações de investimento',
  BROKERAGE_NOTE: 'Notas de corretagem',
};

export function getPluggyProductLabel(product: string): string {
  const normalized = product.trim().toUpperCase();
  return PLUGGY_PRODUCT_LABELS[normalized] ?? normalized.replaceAll('_', ' ').toLowerCase();
}
